import { Seo, breadcrumbLd } from "@/site/seo";
import { CHANGELOG } from "@/site/content";
import { Heading } from "@/site/components/Section";

export default function ChangelogPage() {
  return (
    <>
      <Seo title="Changelog" description="What changed in Postern, dated. Governance, CPQ, reliability and performance releases." jsonLd={[breadcrumbLd([{ name: "Home", path: "/" }, { name: "Changelog", path: "/changelog" }])]} />
      <section className="section">
        <div className="wrap" style={{ maxWidth: 900 }}>
          <Heading eyebrow="Changelog" title="What changed, and when." lede="Dated, specific, and written for the people who run the deals. Subscribe via RSS or ask us to include you on release notes." />
          <div style={{ marginBottom: 20 }}><a className="btn btn--ghost btn--sm" href="/changelog.xml" data-testid="rss-link">RSS feed</a></div>
          <div className="cl" data-testid="changelog">
            {CHANGELOG.map((c) => (
              <article className="cl__item" key={c.date + c.title}>
                <div className="cl__date">{c.date}</div>
                <div>
                  <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}><h3 className="h3" style={{ margin: 0 }}>{c.title}</h3>{c.tags.map((t) => <span className="chip" key={t}>{t}</span>)}</div>
                  <p className="body" style={{ marginTop: 8 }}>{c.body}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
